import React, { useState, useEffect, memo } from 'react';
import { Phone, MessageCircle, Menu, X, Facebook, Instagram } from 'lucide-react';
import { navLinks, company } from '../mock';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrolled((prev) => {
            const next = window.scrollY > 50;
            return prev === next ? prev : next;
          });
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md py-2' : 'bg-white/95 backdrop-blur-sm py-3'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between gap-4">
        <a href="#home" className="flex items-center shrink-0" aria-label="Magic Deumidificazioni - Torna alla home">
          <img src={company.logoUrl} alt="Magic Deumidificazioni Sagl" className="h-10 md:h-12 w-auto object-contain" width="180" height="48" decoding="async" fetchPriority="high" />
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((l) => (
            <a key={l.label} href={l.href} className="text-sm font-semibold text-brand-navy hover:text-brand-red transition-colors relative group">
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand-red transition-all group-hover:w-full" />
            </a>
          ))}
          <a href={company.facebookLink} target="_blank" rel="noreferrer noopener" aria-label="Facebook Magic Deumidificazioni" className="text-brand-navy hover:text-brand-red transition-colors">
            <Facebook className="w-5 h-5" aria-hidden="true" />
          </a>
          <a href={company.instagramLink} target="_blank" rel="noreferrer noopener" aria-label="Instagram Magic Deumidificazioni" className="text-brand-navy hover:text-brand-red transition-colors">
            <Instagram className="w-5 h-5" aria-hidden="true" />
          </a>
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <a href={`tel:${company.phoneRaw}`} aria-label={`Chiama emergenza 24 ore su 24: ${company.phone}`} className="flex items-center gap-2 bg-brand-red hover:bg-brand-red-dark text-white px-4 py-2.5 rounded-md font-semibold text-sm transition-colors pulse-red">
            <span className="hidden xl:inline text-xs uppercase tracking-wide">Emergenza 24/24</span>
            <Phone className="w-4 h-4" aria-hidden="true" />
            <span>{company.phone}</span>
          </a>
          <a href={company.whatsappLink} target="_blank" rel="noreferrer noopener" aria-label="Contattaci su WhatsApp" className="flex items-center gap-2 bg-brand-green hover:brightness-110 text-white px-4 py-2.5 rounded-md font-semibold text-sm transition-all">
            <MessageCircle className="w-4 h-4" aria-hidden="true" />
            <span>WhatsApp</span>
          </a>
        </div>

        <button onClick={() => setMobileOpen(!mobileOpen)} aria-label={mobileOpen ? 'Chiudi menu' : 'Apri menu'} aria-expanded={mobileOpen} aria-controls="mobile-menu" className="lg:hidden p-2 text-brand-navy">
          {mobileOpen ? <X className="w-6 h-6" aria-hidden="true" /> : <Menu className="w-6 h-6" aria-hidden="true" />}
        </button>
      </div>

      {mobileOpen && (
        <div id="mobile-menu" className="lg:hidden bg-white border-t border-gray-200 px-4 py-4 space-y-3 shadow-lg">
          {navLinks.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setMobileOpen(false)} className="block text-brand-navy font-semibold py-2 border-b border-gray-100">{l.label}</a>
          ))}
          <div className="flex gap-2 pt-2">
            <a href={`tel:${company.phoneRaw}`} className="flex-1 flex items-center justify-center gap-2 bg-brand-red text-white py-2.5 rounded-md font-semibold text-sm">
              <Phone className="w-4 h-4" /> {company.phone}
            </a>
            <a href={company.whatsappLink} target="_blank" rel="noreferrer" className="flex-1 flex items-center justify-center gap-2 bg-brand-green text-white py-2.5 rounded-md font-semibold text-sm">
              <MessageCircle className="w-4 h-4" /> WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default memo(Header);
